import {Injectable} from '@angular/core';

@Injectable()
export class PermissionConstant {
  static ALL = 'ALL';

  // Dashboard
  static DASHBOARD = 'DASHBOARDS_DASHBOARD'
  static HOME = 'DASHBOARDS_HOME';

  // General
  static GENERAL = 'GENERALS_GENERAL';
  static ADMIN = 'GENERALS_ADMINS';
  static ADD_ADMIN = 'GENERALS_ADD_ADMINS';
  static LIST_ADMIN = 'GENERALS_LIST_ADMINS';
  static SESSION = 'GENERALS_SESSIONS';
  static ADD_SESSION = 'GENERALS_ADD_SESSIONS';
  static LIST_SESSION = 'GENERALS_LIST_SESSIONS';
  static GENERAL_REPORT = 'GENERALS_REPORTS';

  // Employee
  static EMPLOYEE = 'EMPLOYEES_EMPLOYEE';
  static DESIGNATION = 'EMPLOYEES_DESIGNATIONS';
  static EMPLOYEES = 'EMPLOYEES_EMPLOYEES';
  static ADD_EMPLOYEES = 'EMPLOYEES_ADD_EMPLOYEES';
  static LIST_EMPLOYEES = 'EMPLOYEES_LIST_EMPLOYEES';
  static ATTENDANCE_EMPLOYEES = 'EMPLOYEES_ATTENDANCE_EMPLOYEES';
  static PAYROLL_EMPLOYEES = 'EMPLOYEES_PAYROLL_EMPLOYEES';
  static EMPLOYEES_SUBJECTS_MAPPING_EMPLOYEES = 'EMPLOYEES_SUBJECTS_MAPPING_EMPLOYEES';
  static PERMISSION = 'EMPLOYEES_PERMISSIONS';
  static EMPLOYEE_REPORT = 'EMPLOYEES_REPORTS';

  // Module
  static MODULE = 'MODULES_MODULES';
  static CLASS = 'MODULES_CLASS';
  static SECTION = 'MODULES_SECTION';
  static SUBJECT = 'MODULES_SUBJECT';
  static GROUPING = 'MODULES_GROUPINGS';
  static TIMETABLE = 'MODULES_TIMETABLE';
  static MODULE_REPORT = 'MODULES_REPORTS';

  // Inventory
  static INVENTORY = 'INVENTORIES_INVENTORIES';
  static INVENTORY_CATEGORY = 'INVENTORIES_CATEGORIES';
  static INVENTORY_LIST = 'INVENTORIES_LISTS';
  static INVENTORY_TRANSACTION = 'INVENTORIES_TRANSACTIONS';
  static INVENTORY_REPORT = 'INVENTORIES_REPORTS';

  // Book
  static BOOK = 'BOOKS_BOOKS';
  static BOOK_CATEGORY = 'BOOKS_CATEGORIES';
  static BOOK_LIST = 'BOOKS_LISTS';
  static BOOK_TRANSACTION = 'BOOKS_TRANSACTIONS';
  static BOOK_REPORT = 'BOOKS_REPORTS';

  // Library
  static LIBRARY = 'LIBRARIES_LIBRARIES';
  static LIBRARY_BORROWING = 'LIBRARIES_BORROWINGS';
  static LIBRARY_TRANSACTION = 'LIBRARIES_TRANSACTIONS';
  static LIBRARY_TRANSACTION_STATUS: string = 'LIBRARIES_TRANSACTIONS_STATUS';
  static LIBRARY_REPORT = 'LIBRARIES_REPORTS';

  // Student
  static STUDENT = 'STUDENTS_STUDENTS';
  static STUDENT_ADD = 'STUDENTS_ADD_STUDENTS';
  static STUDENT_LIST = 'STUDENTS_LIST_STUDENTS';
  static STUDENT_VERIFY = 'STUDENTS_VERIFY_STUDENTS';
  static STUDENT_TRANSACTION = 'STUDENTS_TRANSACTION_STUDENTS';
  static STUDENT_ATTENDANCE = 'STUDENTS_ATTENDANCE_STUDENTS';
  static STUDENT_ENROLLMENT = 'STUDENTS_ENROLLMENT_STUDENTS';
  static FINAL_STUDENT_LIST = 'STUDENTS_FINAL_STUDENT_LIST';
  static STUDENT_REPORT = 'STUDENTS_REPORT_STUDENTS';

  // Account
  static ACCOUNT_ACCOUNT = 'ACCOUNTS_ACCOUNTS';
  static ACCOUNT_RECEIPT = 'ACCOUNTS_RECEIPTS';
  static ACCOUNT_RECEIPT_TRANSACTION = 'ACCOUNTS_RECEIPT_TRANSACTIONS';
  static ACCOUNT_WALLET_TRANSACTION = 'ACCOUNTS_WALLET_TRANSACTIONS';
  static ACCOUNT_REPORT = 'ACCOUNTS_REPORTS';

  // Utilities
  static UTILITIES = 'UTILITIES_UTILITIES';
  static UTILITIES_HOSTEL = 'UTILITIES_HOSTELS';
  static UTILITIES_VEHICLE = 'UTILITIES_VEHICLES';
  static UTILITIES_HOLIDAY = 'UTILITIES_HOLIDAYS';
  static UTILITIES_SCHOLARSHIP = 'UTILITIES_SCHOLARSHIP';
  static UTILITIES_VISITOR = 'UTILITIES_VISITOR';
  static UTILITIES_REPORT = 'UTILITIES_REPORTS';

  // Alumni
  static ALUMNI = 'ALUMNIS_ALUMNIS';
  static ALUMNI_LIST = 'ALUMNIS_LIST';

  static UNIFORMS = 'UNIFORMS_UNIFORMS';
  static UNIFORMS_LIST = 'UNIFORMS_STOCK';
  static UNIFORMS_STOCK = 'UNIFORMS_LIST';
  static UNIFORMS_TRANSACTION_LIST = 'UNIFORMS_TRANSACTION_LIST';

  // Event
  static EVENTS = 'EVENTS_EVENTS';
  static EVENTS_LIST = 'EVENTS_LISTS';
  static EVENTS_PARTICIPANTS = 'EVENTS_PARTICIPANTS';
  static EVENTS_EXTRA_CURRICULAR = 'EVENTS_EXTRA_CURRICULAR';
  static EVENTS_EXTRA_CURRICULAR_PARTICIPANTS = 'EVENTS_EXTRA_CURRICULAR_PARTICIPANTS';

  // Support Ticket
  static SUPPORT_TICKET = 'SUPPORTS_TICKETS_SUPPORT_TICKETS';
  static STUDENT_SUPPORT_TICKET = 'SUPPORTS_TICKETS_STUDENT_TICKETS';
  static SUPPORT_TICKET_REPORT = 'SUPPORTS_TICKETS_REPORTS';

  // Notification
  static NOTIFICATION = 'NOTIFICATIONS_NOTIFICATIONS';
  static STUDENT_NOTIFICATION = 'NOTIFICATIONS_STUDENT_NOTIFICATIONS';
  static PARENT_NOTIFICATION = 'NOTIFICATIONS_PARENT_NOTIFICATIONS';
  static NOTIFICATION_REPORT = 'NOTIFICATIONS_REPORTS';

// Parent
  static PARENT = 'PARENTS_PARENTS';
  static ADD_PARENT = 'PARENTS_ADD_PARENTS';
  static LIST_PARENT = 'PARENTS_LIST_PARENTS';
  static PARENT_REPORT = 'PARENTS_REPORTS';
}
